import type { TranscriptSpeakerPayload } from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakersFetched';

export type TranscriptSpeakerAssignedAction = {
	type: 'TRANSCRIPT_SPEAKER_ASSIGNED';
	payload: TranscriptSpeakerPayload;
	interviewId: number;
};

export default (payload: TranscriptSpeakerPayload, interviewId: number): TranscriptSpeakerAssignedAction => ({
	type: 'TRANSCRIPT_SPEAKER_ASSIGNED',
	payload,
	interviewId,
});
